/*
 * @开发: 东南,战兔
 * @测试: 喵喵
 * @活动ID: 10152
 * @活动名称: 庆典预热
 * @上线的国家列表: US,DE,TW,IN,JP,MY,FR,TH,EG,VN,PH,ID,TR
 * @需求文档: https://micoworld.feishu.cn/wiki/XYQCwD836ioUIPk9yEycPL9qnLh
 * @文案链接: https://micoworld.feishu.cn/wiki/LyzjwLaufirIMhkprn3cjOZQnzc
 * @活动链接: https://activity-h5.voicemaker.media/act_202411_PreludeRank/index.html?fullPage=true&amp;bounces=0&amp;lang=
 * @运营位链接: 
 * @分享链接: 
 * @设计图链接: https://www.figma.com/design/r2Ri4RdRp7FOjtCV3KCvAB/2024%E5%B9%B4%E5%BA%A6%E7%9B%9B%E5%85%B8-DQ%EF%BC%86%E5%AD%90%E8%99%9A?node-id=100-14927&amp;node-type=instance&amp;m=dev
 * @生成模板版本: v3.8.2
 */
import { createApp } from 'vue';
import App from './app.vue';
import animate from '@activity-business/h5-package-vue3Animate';
import developTool_share from '@components/developTool_share';
import { getLanguage } from '@library/activityPublic';
import './scss/public_class.scss';

const app = createApp(App);
const rootDom = document.createElement('div');
rootDom.setAttribute('id', 'root');
document.body.appendChild(rootDom);

//此页面用于用户站外分享，拿不到用户信息，所以没有使用developTool工具 而是用developTool_share工具
const countryList = ["US","DE","TW","IN","JP","MY","FR","TH","EG","VN","PH","ID","TR"];

getLanguage(countryList).then(lang => {
    //  第一个国家、地区码为默认值
    app.use(animate).use(developTool_share, {
        activityId: 10152, 
        countryCode: lang,
        moduleVersion: { toast: 'v2' },
        componentConfig: {
            // 图片资源文件名
            image: { p: "202411_PreludeRank" }
        }
    }).mount(rootDom);
});